import Box, { BoxProps } from '../Box'

interface ScrolledContainerProps {
  horizontal?: boolean
  disable?: boolean
  showScrollBar?: boolean
  sx?: BoxProps['sx']
}

const ScrolledContainer: RFC<ScrolledContainerProps> = ({
  horizontal,
  disable,
  showScrollBar,
  sx,
  children
}) => {
  return (
    <Box
      sx={{
        ...(!horizontal && { overflowY: 'scroll' }),
        ...(horizontal && { overflowX: 'scroll' }),
        ...(disable && { overflow: 'hidden' }),
        ...(!showScrollBar && {
          // hide scrollbar
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }),
        ...sx
      }}
    >
      {children}
    </Box>
  )
}

export default ScrolledContainer
